import icon from './icon';
import cate from './cate';
export default {
   icon,
   cate
};